import React, { useState } from 'react'
import { IconContext } from 'react-icons'
import { IconTooltip as Tooltip } from '../Tooltip'
import { FaCompressArrowsAlt, FaExpandArrowsAlt } from 'react-icons/fa'
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io'

const CollapseButton = ({ name, isCollapsed, setIsCollapsed }) => {
    return (
        <div
            className="panelHeaderIconDiv"
            data-tip={`Collapse / Expand`}
            data-for={`${name}-collapsed-${isCollapsed}`}
            onClick={() => setIsCollapsed(!isCollapsed)}
        >
            {isCollapsed ? <IoIosArrowUp /> : <IoIosArrowDown />}
            <Tooltip id={`${name}-collapsed-${isCollapsed}`} />
        </div>
    )
}

export default CollapseButton
